import React from "react";
import FilterNoneOutlinedIcon from "@mui/icons-material/FilterNoneOutlined";
import Tooltip from "@material-ui/core/Tooltip";

const EventIcon = () => {
  return (
    <Tooltip title="'Event' Interaction">
      <FilterNoneOutlinedIcon
        color="primary"
        sx={{
          color: "#d9d9d9",
          fontSize: "30pt",
          float: "right",
          marginTop: "20px",
        }}
      />
    </Tooltip>
  );
};

export default EventIcon;
